import * as React from 'react';
import { JSX, useState } from 'react';
import styled from '@emotion/styled';
import { SidebarWidget } from './SidebarWidget';
import { immediateAction } from '../../utils';

export interface SidebarPageWidgetProps {
  sidebarLeft: (handles: { close: () => any }) => JSX.Element;
  sidebarRight: (handles: { close: () => any }) => JSX.Element;
  getContent: (handles: { showLeft: () => any; showRight: () => any }) => JSX.Element;
}

export const SidebarPageWidget: React.FC<SidebarPageWidgetProps> = (props) => {
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [ltr, setLtr] = useState(true);

  const handles = {
    close: () => {
      setShowRight(false);
      setShowLeft(false);
    }
  };

  return (
    <S.Container ltr={ltr}>
      <S.Sidebar width={300} show={showLeft}>
        {props.sidebarLeft(handles)}
      </S.Sidebar>
      <S.Sidebar
        width={300}
        show={showRight}
        hidden={() => {
          setLtr(true);
        }}
      >
        {props.sidebarRight(handles)}
      </S.Sidebar>
      <S.Content borderLeft={showLeft} borderRight={showRight}>
        {props.getContent({
          showLeft: () => {
            setShowLeft(!showLeft);
          },
          showRight: () => {
            setShowRight(!showRight);
            setLtr(false);
          }
        })}
        {showLeft || showRight ? (
          <S.Overlay
            {...immediateAction(() => {
              setShowLeft(false);
              setShowRight(false);
            })}
          ></S.Overlay>
        ) : null}
      </S.Content>
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div<{ ltr: boolean }>`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    height: 100%;
    direction: ${(p) => (p.ltr ? 'ltr' : 'rtl')};
  `;

  export const Content = styled.div<{ borderLeft: boolean; borderRight: boolean }>`
    position: relative;
    min-width: 100vw;
    min-height: 100vh;
    box-sizing: border-box;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    border-left: ${(p) => (p.borderLeft ? `solid 1px ${p.theme.layout.border}` : 'none')};
    border-right: ${(p) => (p.borderRight ? `solid 1px ${p.theme.layout.border}` : 'none')};
    z-index: 2;
    direction: ltr;
  `;

  export const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `;

  export const Sidebar = styled(SidebarWidget)`
    direction: ltr;
  `;
}
